export default __webpack_public_path__ + "static/media/pdf.30a8850a.svg";